import {Helper} from "../../../assets/ts/global.ts";
import {LocalizationHelper} from "../../../assets/ts/localizationHelper.ts";
import Loading from "../../widgets/loading/loading.vue";

const helper = new Helper();
const localization = new LocalizationHelper();

export default {
    props: [
        "useTitle",
        "widthSize",
        "heightSize",
        "className",
        "title",
        "breadcrumbData",
        "isCompletedTask",
        "loading",
        "customStyle"
    ],
    data() {
        return {
            currentDate: "",
            isPlugin: payload.isPlugin,
            isHideFormHeader: payload.isHideFormHeader,
            isHideFormToolbar: payload.isHideFormToolbar,
            isHideAll: payload.isHideAll
        }

    },
    mounted() {
        this.currentDate = localization.getDateByCulture(new Date());
    },
    components: {
        Loading
    }
}
